import React from 'react'
import {NavLink} from "react-router-dom"
import config from "../config.json"

export class MainPageNotAuthClass extends React.Component {

    render() {

        const {lang, currentLang} = this.props

        let styleText = 'text-start'
        if (currentLang === 'he' || currentLang === 'ar') {
            styleText = 'text-end'
        }

        const arrLinks = [
            {
                "name": lang.navbar.isNotAuth.btnAuth,
                "link": `/${currentLang}/auth-form`,
                "className": "Auth",
                "bodyClass": ""
            },
            {
                "name": lang.navbar.isNotAuth.btnRegister,
                "link": `/${currentLang}/register-form`,
                "className": "Register",
                "bodyClass": ""
            },
            {
                "name": lang.navbar.isAuth.btnPublicLinks,
                "link": `/${currentLang}/folder/open-public/${config.trialRootFolderId}`,
                "className": "PublicLinks",
                "bodyClass": ""
            }
        ]

        return (
            <>
                <div className={"d-flex justify-content-center flex-wrap"}>

                    <div className={'container mt-4'}>
                        <div className={`ps-4 container col col-lg-8 ${styleText}`}>
                            <h1 className={'mb-4 fw-bold text-dark text-center'}>{lang.body.welcome.h1_0}</h1>
                            <p>{lang.body.welcome.p1_0}<br />{lang.body.welcome.p1_1}</p>
                            <p>{lang.body.welcome.p2_0}<br />{lang.body.welcome.p2_1}</p>
                            {(currentLang === 'he' || currentLang === 'ar') && <p>{lang.body.welcome.p3_0}<br />{lang.body.welcome.p3_1}<br /><a href={lang.body.welcome.a1_href}>{lang.body.welcome.a1_0}</a></p>}
                            {(currentLang !== 'he' && currentLang !== 'ar') && <p>{lang.body.welcome.p3_0}<br />{lang.body.welcome.p3_1}<a href={lang.body.welcome.a1_href}>{lang.body.welcome.a1_0}</a></p>}
                        </div>
                    </div>

                    <NavLink
                        to={`${arrLinks[0].link}`}
                        className={`card text-decoration-none m-3 col-10 col-lg-4 col-sm-3 ${arrLinks[0].className}`}>
                        <div className={"m-1 w-auto"}>
                            <div className={`card border-primary p-3 text-center ${arrLinks[0].bodyClass}`}>
                                <div className={"card-body text-success pt-1 ps-2 pe-2 pb-0"}>
                                    <h5 className={"card-title title-card"}><strong
                                        id={'main-page-button-' + 0}>{arrLinks[0].name}</strong>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </NavLink>

                    <NavLink
                        to={`${arrLinks[1].link}`}
                        className={`card text-decoration-none m-3 col-10 col-lg-4 col-sm-3 ${arrLinks[1].className}`}>
                        <div className={"m-1 w-auto"}>
                            <div className={`card border-primary p-3 text-center ${arrLinks[1].bodyClass}`}>
                                <div className={"card-body text-success pt-1 ps-2 pe-2 pb-0"}>
                                    <h5 className={"card-title title-card"}><strong
                                        id={'main-page-button-' + 1}>{arrLinks[1].name}</strong>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </NavLink>

                    {(currentLang === 'ru') && <NavLink
                        to={`${arrLinks[2].link}`}
                        className={`card text-decoration-none m-3 col-10 col-lg-4 col-sm-3 ${arrLinks[2].className}`}>
                        <div className={"m-1 w-auto"}>
                            <div className={`card border-primary p-3 text-center ${arrLinks[2].bodyClass}`}>
                                <div className={"card-body text-success pt-1 ps-2 pe-2 pb-0"}>
                                    <h5 className={"card-title title-card"}><strong
                                        id={'main-page-button-' + 2}>{arrLinks[2].name}</strong>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </NavLink>}

                </div>
            </>
        )
    }
}
